import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, NgForm, Form } from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import { NgbModal, NgbModalConfig, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationStart, ActivatedRoute } from "@angular/router";
import { AssessmentService } from "../../services/assessment.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
interface objectEmit {
  capsule_id: any,
  status: boolean
}

@Component({
  selector: 'app-course-content-capsule',
  templateUrl: './course-content-capsule.component.html',
  styleUrls: ['./course-content-capsule.component.scss']
})
export class CourseContentCapsuleComponent implements OnInit {
  @Output() finalSubmitCap: any = new EventEmitter();
  @Input() capData: any;returnObj: objectEmit = { capsule_id: null, status: false };adminData: any;
  capsuleData:any;order:any = "DESC";order_by:any='created_dttm';search_text:any='';capsule_id:any='';
  copsuleId:any='';closeResult: any = '';
  constructor(private modalService: NgbModal, private config: NgbModalConfig, private auth: AssessmentService, private router: Router,
     private spinner: NgxSpinnerService,private authcourse: CourseService)  { 
     }

     form = new FormGroup({
      capsule: new FormControl('', Validators.required)
    });
  
     /********capsule listing data ****/
      capsuleListData(){
        this.spinner.show()
        this.authcourse.capsuleListing(this.search_text,this.order_by,this.order).subscribe(
          data => {
           console.log(data);
            if(data.status==200){
              this.spinner.hide()
              this.capsuleData =  data.activeContentCapsules;
            }
          }, error => {
            this.spinner.hide()
          }
        );
      }
      /******serching */
      search(event: any) {
        this.search_text = event.target.value;
        this.authcourse.capsuleListing(this.search_text,this.order_by,this.order).subscribe(
          data => {
            if(data.status==200){
              this.capsuleData =  data.activeContentCapsules;
            }
          }, error => { }
        );
      }
      sortData(sort: any) {
        if (sort.direction == 'desc') {
          this.order_by = sort.active; this.order = 'DESC';
        } else if (sort.direction == 'asc') {
          this.order_by = sort.active; this.order = 'ASC';
        } else { this.order_by = 'created_dttm'; this.order = 'DESC'; }
        this.authcourse.capsuleListing(this.search_text,this.order_by,this.order).subscribe(
          data => {
            if(data.status==200){
              this.capsuleData =  data.activeContentCapsules;
            }
          }, error => {
          }
        );
      }
      /*****assign capsule to add sub module ********/
      assignCapsule(){
          if(this.copsuleId !=''){
            this.spinner.show();
            this.returnObj.capsule_id = this.copsuleId;
            this.returnObj.status = true;
            this.finalSubmitCap.emit(this.returnObj);
            //this.spinner.hide();
          }
      }
      /*****get select value of capsule radio**** */
      radioChange(event: any) {
        this.copsuleId = event.value;
      }
      open(content: any) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return `with: ${reason}`;
        }
      }
      /***cnacel to back add module page **/
      onBackToAuthCr() {
        this.spinner.show()
        document.getElementById('cancelId')?.click();
        this.finalSubmitCap.emit(this.returnObj);
        this.spinner.hide()
      }
      logout(){
       // localStorage.clear();
        localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
        this.router.navigate(['./admin-login']);
       }
      ngOnInit(): void {
        this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
        this.capsuleListData();
      }

}
